import axios, { AxiosError } from "axios";
import { UseQueryResult, useQuery } from "react-query";
import { SiteEmployeesResponse } from "../model/SiteEmployee";

interface SiteEmployeesRequest {
  locationId: string;
  exclude?: number;
  search?: string;
  enabled?: boolean;
}

const SiteEmployeesApiService = async (
  request: SiteEmployeesRequest
): Promise<SiteEmployeesResponse> => {
  const params: Record<string, string> = {};
  if (request.exclude) params.exclude = String(request.exclude);
  if (request.search) params.search = request.search;

  const { data } = await axios.get(
    `/shift-locations/${request.locationId}/employees/`,
    { params }
  );
  return data;
};

const useSiteEmployeesApiService = (
  request: SiteEmployeesRequest
): UseQueryResult<SiteEmployeesResponse, AxiosError> =>
  useQuery<SiteEmployeesResponse, AxiosError>(
    [
      "SiteEmployeesApiService",
      request.locationId,
      request.exclude,
      request.search,
    ],
    () => SiteEmployeesApiService(request),
    {
      enabled: request.enabled !== false && Boolean(request.locationId),
      keepPreviousData: true,
    }
  );

export { SiteEmployeesApiService, useSiteEmployeesApiService };
